import { _ } from "libs";
import React, { Component } from "react";
import { OfficialRating, Ratings } from "../../../types";
import ITNLevelInput from "./itnLevelInput";
import NationalRatingInput from "./nationalRatingInput";
import Modal from "../../modal";
import { deleteLicense } from "../../../actions";

type Input = {
	name: string;
	onBlur: (event?: React.FocusEvent<HTMLElement>) => void;
	onChange: (event: React.ChangeEvent<HTMLElement>) => void;
	onFocus: (event?: React.FocusEvent<HTMLElement>) => void;
	value: any;
	checked?: boolean;
};

const NationalRatingPreview = ({
	country,
	ratingValue,
	officialRating,
	onClick,
	onResetClicked,
}: {
	country: string;
	ratingValue: string;
	officialRating?: OfficialRating;
	onClick;
	onResetClicked;
}) => {
	return (
		<div className="dropdown2" onClick={onClick}>
			{officialRating?.code && (
				<>
					<div className="dropdownImage">
						<div className="icon" data-federation={officialRating.code} />
					</div>
					<div className="dropdownBody">
						{_("player.skill.rating")}: {ratingValue}
					</div>
				</>
			)}
			{!officialRating?.code && (
				<>
					<div className="dropdownImage">
						<div className="icon flag" data-country={country} />
					</div>
					<div className="dropdownBody">{ratingValue}</div>
				</>
			)}
			<div
				className="dropdownIcon cancel"
				onClick={(e) => {
					e.stopPropagation();
					onResetClicked();
				}}
			/>
			<input value={country + ": " + ratingValue} type="hidden" readOnly />
		</div>
	);
};

type SelectProps = {
	input: Input;
	ratings: Ratings;
	country?: string;
	rating?: string;
	officialRating?: OfficialRating;
	userId: string;
	values?: any;
};

type SelectState = {
	showNationalRatingModal: boolean;
	value: any;
	officialRating: OfficialRating;
};

export default class SkillSelect extends Component<SelectProps, SelectState> {
	constructor(props: SelectProps) {
		super(props);

		this.state = {
			showNationalRatingModal: false,
			value: props.input.value,
			officialRating: props.officialRating,
		};
	}

	handleShowNationalRatingModal = () => {
		this.setState({ showNationalRatingModal: true });
	};

	handleHideNationalRatingModal = () => {
		this.setState({ showNationalRatingModal: false });
	};

	handleReset = async () => {
		const unlinkRating = window.confirm(_("form.rating.removeConfirmation"));

		if (!unlinkRating) {
			return;
		}

		const value = { ITN: null, country: null, ratingValue: null };
		if (this.props.officialRating?.code) {
			await deleteLicense(this.props.officialRating.code);
		}
		this.setState({ value }, () => {
			this.props.input.onChange(this.state.value);
		});
	};

	onNationalRatingChange = (nationalRating) => {
		const value = { ITN: null, country: nationalRating.country, ratingValue: nationalRating.rating };
		this.setState({ showNationalRatingModal: false, value, officialRating: nationalRating.officialRating }, () => {
			this.props.input.onChange(this.state.value);
		});
	};

	onITNLevelChange = (ITN) => {
		const value = { ITN, country: null, ratingValue: null };
		this.setState({ value }, () => {
			this.props.input.onChange(this.state.value);
		});
	};

	render() {
		return (
			<>
				{this.state.value.country === null && this.state.value.ITN === null ? (
					<>
						<div className="dropdown2" onClick={this.handleShowNationalRatingModal}>
							<div className="dropdownBody">{_("onboarding.nationalRatingModal.linkText")}</div>
							<div className="dropdownIcon down" />
						</div>
						<ITNLevelInput
							ratings={this.props.ratings}
							onChange={this.onITNLevelChange}
							value={this.state.value.ITN}
							asLink={true}
							onResetClicked={this.handleReset}
						/>
					</>
				) : this.state.value.country === null && this.state.value.ITN !== null ? (
					<ITNLevelInput
						ratings={this.props.ratings}
						onChange={this.onITNLevelChange}
						value={this.state.value.ITN}
						asLink={false}
						onResetClicked={this.handleReset}
					/>
				) : (
					<NationalRatingPreview
						onClick={this.handleShowNationalRatingModal}
						onResetClicked={this.handleReset}
						country={this.state.value.country}
						ratingValue={this.state.value.ratingValue}
						officialRating={this.state.officialRating}
					/>
				)}
				{this.state.showNationalRatingModal ? (
					<Modal
						title={_("onboarding.nationalRatingModal.heading")}
						onCloseClicked={this.handleHideNationalRatingModal}
					>
						<NationalRatingInput
							country={this.props.country}
							rating={this.props.rating}
							onResetClicked={this.handleReset}
							ratings={this.props.ratings}
							officialRating={this.props.officialRating}
							onChange={this.onNationalRatingChange}
							userId={this.props.userId}
						/>
					</Modal>
				) : null}
			</>
		);
	}
}
